export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyCXNgTNBzYZ_M-t7a4CWoqwWWgEsmAiB8s",
    authDomain: "secondbrandorg.firebaseapp.com",
    databaseURL: "https://secondbrandorg-default-rtdb.firebaseio.com",
    projectId: "secondbrandorg",
    storageBucket: "secondbrandorg.appspot.com",
    messagingSenderId: "80763592286",
    appId: "1:80763592286:web:13bfb87c9ec42698215ecf"
};
